import { Controller } from '@hotwired/stimulus'
import Zoomist from 'zoomist'

export default class extends Controller {
  static values = { id: String }

  connect() {
    this.handleImageLoadedFn = this.handleImageLoaded.bind(this)
    document.addEventListener('image-loaded', this.handleImageLoadedFn)
  }

  disconnect() {
    document.removeEventListener('image-loaded', this.handleImageLoadedFn)
    if (this.zoomist) {
      this.zoomist.destroy()
    }
  }

  get options() {
    return {
      smooth: true,
      maxScale: 4,
      zoomer: true
    }
  }

  handleImageLoaded(event) {
    if (event.detail.id === this.idValue) {
      this.zoomist = new Zoomist(this.element, this.options)
    }
  }
}
